// extracted by mini-css-extract-plugin
export default {"rootClassName":"contrato-dados-contrato-ente-publico-card"};